import { upperFirst } from 'lodash'
import React from 'react'

import { Provider, TripsAggregations } from 'src/api/gen/api'
import { IFacet } from 'src/api/types/facet'
import { sortObjectsByLabel } from 'src/commons/helpers'
import { getTranslation } from 'src/commons/i18n'
import ColorDot from 'src/components/ColorDot'
import { POLICY_TYPES_ICONS } from 'src/components/Offenses'
import { IOption } from 'src/muiv5/components/commons/SidePanel/Filters/CheckboxListFilter/CheckboxListFilter'
import { LOCATION_TYPES_COLOR } from 'src/theme'

export function getEnumEntries(
  filterEnum: string[],
  translationEnum: { [index: string]: string },
  counter?: IFacet,
  plural = true
): IOption[] {
  const { t } = getTranslation()
  return filterEnum.map((enumItem) => {
    const name = translationEnum[enumItem]
    const translatedName = plural ? upperFirst(t(name, { count: 2 })) : upperFirst(t(name))

    return {
      id: enumItem,
      label: translatedName,
      value: counter && counter[enumItem],
    }
  })
}

export function getProviderEntries(
  providers: Provider[],
  providerCounter?: IFacet | TripsAggregations['provider_id'],
  displayProviderColor = false
) {
  const providerEntries = providers
    .map((provider: Provider) => {
      const { id, colors, name } = provider
      const mainColor = colors ? colors.primary : undefined
      const borderColor = colors ? colors.secondary : undefined

      return {
        id,
        label: name,
        value: providerCounter && providerCounter[id],
        endAdornment: displayProviderColor ? <ColorDot mainColor={mainColor} borderColor={borderColor} /> : undefined,
      }
    })
    .sort(sortObjectsByLabel)

  return providerEntries
}

export function getLocationTypeEntries(
  locationTypes: string[],
  translationEnum: { [index: string]: string },
  displayLocationTypeColor = false
) {
  const { t } = getTranslation()

  const colors: { [key: string]: string } = {}
  for (const [key, colorSpecifier] of Object.entries(LOCATION_TYPES_COLOR)) {
    colors[key] = colorSpecifier
  }

  const locationTypeEntries = locationTypes
    .map((locationType: string) => {
      const name = upperFirst(t(translationEnum[locationType]))
      const color = locationType in colors ? colors[locationType] : undefined

      return {
        id: locationType,
        label: name,
        endAdornment: displayLocationTypeColor ? <ColorDot mainColor={color} /> : undefined,
      }
    })
    .sort(sortObjectsByLabel)

  return locationTypeEntries
}

export function getPolicyKindEntries(
  policyKinds: { id: string; label: string }[],
  policyKindsAggregations?: IFacet,
  displayPolicyLogo = true
) {
  return (
    policyKinds
      .map((item: { id: string; label: string }) => ({
        value: policyKindsAggregations?.[item.id],
        endAdornment: displayPolicyLogo ? <img height="18" src={(POLICY_TYPES_ICONS as any)[item.id]} /> : undefined,
        ...item,
      }))
      // this sortObjectsByLabel function returns 1, 0 or -1
      // entry 1 < entry 2 <=> function returns -1
      .sort(sortObjectsByLabel)
  )
}
